import { EFieldType } from '@timeedit/types/lib/enums/field.enum';
import type { TField } from '@timeedit/types/lib/types/field.type';

const READ_ONLY_FIELD_TYPES: EFieldType[] = [
  EFieldType.REFERENCE,
  EFieldType.NON_SEARCHABLE_REFERENCE,
];

// Reference fields are derived server-side: they can be read back, but never written.
export const isReadOnlyField = (field: TField | undefined) => {
  return (
    field != null &&
    READ_ONLY_FIELD_TYPES.includes(field.fieldType as EFieldType)
  );
};

export const isFieldSaveable = (field: TField | undefined) => {
  return field != null && !isReadOnlyField(field);
};

export const isReferenceField = (field: TField | undefined) => {
  return field?.fieldType === EFieldType.REFERENCE;
};

export const fieldFilterValues = (
  objectField: { fieldId: number | string; values: string[] },
  fieldMap: Record<number, TField | undefined>
): string => {
  const field = fieldMap[objectField.fieldId as number];
  const isCheckbox = field?.fieldType === EFieldType.CHECKBOX;
  const values = isCheckbox
    ? objectField.values.map((v) => (v === '1' ? 'True' : 'False'))
    : objectField.values;
  return `${field?.name || `Field ${objectField.fieldId}`}: ${values.join(
    ', '
  )}`;
};
